import ApplyTrialBox, { ApplyTrialParam } from '@/components/ApplyTrialBox/ApplyTrialBox'
import styles from './FreeTrialPagePc.module.less'
import { observer } from 'mobx-react'
import { api } from '@/api'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { PAGE_LINKS } from '@/router/pageConst'
import { useTranslation } from 'react-i18next'
import { corpService } from '@/services/corpService'


interface Props {
  userInfo: Models.UserInfo
}
function FreeTrialPagePc({ userInfo, }: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const onSubmit = async (param: ApplyTrialParam) => {
    try {
      await api.corp.applyForFreeTrial(param).send()
      corpService.refreshFreeTrialStatus(undefined, { force: true })
      navigate(PAGE_LINKS.projectCreate)
      message.success(t('modals.freeTrialModal.message.submitSuccess'))
    } catch (e: any) {
      const error = e as ApiError
      // console.error(error.statusMessage)
      // message.error(t('modals.freeTrialModal.message.submitFailed'))
      message.error(error.statusMessage)
    }
  }

  return <div className={styles.freeTrialPage} data-testid='free-trial-page'>
    <div className={styles.freeTrialPageContent}>
      <div className={styles.card}>
        <div className={styles.cardInner}>
          <p className={styles.title}>{t('modals.freeTrialModal.title')}</p>
          <ApplyTrialBox userInfo={userInfo} onSubmit={onSubmit} />
        </div>
        <div className={styles.cardBg}></div>
      </div>
    </div>
  </div>
}

export default observer(FreeTrialPagePc)
